// extracted by mini-css-extract-plugin
export default {"pricing":"pricing__MWJmO","section":"section__NDdiY","title":"title__ZWYyY","icon":"icon__N2QyY","link":"link__ZWJmO"};